module.exports = __webpack_public_path__ + "static/media/agent3.a27ee868.png";